import { render, staticRenderFns } from "./TabelaRecebimentosAvulsos.vue?vue&type=template&id=902d0d5c&scoped=true&"
import script from "./TabelaRecebimentosAvulsos.vue?vue&type=script&lang=js&"
export * from "./TabelaRecebimentosAvulsos.vue?vue&type=script&lang=js&"
import style0 from "./TabelaRecebimentosAvulsos.vue?vue&type=style&index=0&id=902d0d5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "902d0d5c",
  null
  
)

export default component.exports